import { Card, CardContent, CardHeader } from '@/components/ui/card'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { Info } from 'lucide-react'

export type KpiCardProps = {
  title: string
  value: string
  description?: string
  tooltip?: string
}

export default function KpiCard({
  title,
  value,
  description,
  tooltip,
}: KpiCardProps) {
  return (
    <Card>
      <CardHeader className='flex flex-row items-start justify-between'>
        <div className='text-sm text-muted-foreground flex items-center gap-2'>
          {title}
          {tooltip ? (
            <TooltipProvider delayDuration={150}>
              <Tooltip>
                <TooltipTrigger
                  aria-label={`Info: ${title}`}
                  className='inline-flex h-5 w-5 items-center justify-center rounded hover:bg-muted/60 '
                >
                  <Info className='h-4 w-4' />
                </TooltipTrigger>
                <TooltipContent className='max-w-xs whitespace-pre-wrap dark:bg-primary dark:text-white'>
                  {tooltip}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : null}
        </div>
      </CardHeader>
      <CardContent>
        <div className='text-3xl font-semibold'>{value}</div>
        {description ? (
          <p className='mt-1 text-xs text-muted-foreground leading-snug'>
            {description}
          </p>
        ) : null}
      </CardContent>
    </Card>
  )
}
